export default __webpack_public_path__ + "static/media/NI.9b7c3993.svg";